import { Alert } from '@coolblue-development/freddy';
import { ApplicationFailureMessage } from '@sharedTypes';
import React from 'react';

export const FailureMessage = ({ title, text }: ApplicationFailureMessage) => {
  return <Alert intent='error' title={title} description={text} />;
};
